export const PACKAGE_NAME = 'jiraDashboardEdit';

export const IGNORE_LOG: {
	pattern: RegExp;
	ignoredBecause: string;
	jiraIssueId: `${string}-${number}`;
}[] = [
	{
		pattern: /React does not recognize/,
		ignoredBecause:
			'Warning from `createAnalyticsEvent` prop being forwarded to Atlaskit DropdownMenu.',
		jiraIssueId: 'DAG-688',
	},
	{
		pattern: /The above error occurred in the (.+?) component/,
		ignoredBecause:
			'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
		jiraIssueId: 'DAG-688',
	},
	{
		pattern: /jira.frontend.common.error-boundary/,
		ignoredBecause: 'Unhandled error caught by error boundary',
		jiraIssueId: 'DAG-688',
	},
	{
		pattern: /jira.frontend.experience-tracker.missing-provider/,
		ignoredBecause: 'Unhandled error caught by error boundary',
		jiraIssueId: 'DAG-688',
	},
	{
		pattern: /Failed to load resource: the server responded with a status of 404/,
		ignoredBecause:
			'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
		jiraIssueId: 'DAG-688',
	},
	{
		pattern: /rest\/internal\/2\/log\/safe\/error/,
		ignoredBecause:
			'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
		jiraIssueId: 'DAG-688',
	},
	{
		pattern: /Encountered two children with the same key/,
		ignoredBecause:
			'this is a stub `avatarUrl` for asset "/secure/viewavatar?size=medium&avatarId=10315&avatarType=issuetype"',
		jiraIssueId: 'DAG-688',
	},
	{
		pattern: /Unrecognised gadget type/,
		ignoredBecause: 'exception thrown: Unrecognised gadget type',
		jiraIssueId: 'DAG-688',
	},
	{
		pattern: /FetchError: Error server response/,
		ignoredBecause: 'exception thrown: Error server response',
		jiraIssueId: 'DAG-688',
	},
];

export const MAX_ALLOWED_GADGETS_COUNT = 20 as const;
export const MAX_GADGETS_COUNT_INCLUDE_IGNORED_GADGETS = 50 as const;
export const IGNORED_GADGETS_FROM_COUNT_MAP = {
	'rest/gadgets/1.0/g/com.atlassian.jira.atlassian-wallboard-plugin:spacer-gadget/gadgets/spacerGadget.xml':
		'jira-dashboard-items/spacer',
} as const;
